import React from "react";
import { X } from "lucide-react";

const Modal = ({ isOpen, onClose, title, children, className = "" }) => {
	if (!isOpen) return null;

	return (
		<div className='fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200'>
			<div
				className={`bg-white rounded-2xl shadow-xl w-full max-w-md relative animate-in zoom-in-95 duration-200 ${className}`}
				role='dialog'
				aria-modal='true'
			>
				<button
					onClick={onClose}
					className='absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors'
					aria-label='Close modal'
				>
					<X size={20} />
				</button>

				<div className='p-6'>
					{title && (
						<h3 className='text-xl font-bold text-gray-900 mb-4 pr-8'>{title}</h3>
					)}
					<div className='text-gray-600'>{children}</div>
				</div>
			</div>
		</div>
	);
};

export default Modal;
